import { formatDateLong } from '@department-of-veterans-affairs/platform-utilities/exports';

// separator used in txt files
export const txtLine = '_____________________________________________________';

// dotted separator
export const txtLineDotted =
  '-----------------------------------------------------';

// the Crisis Line header that must go at the top of all txt files
export const crisisLineHeader =
  "If you're ever in crisis and need to talk with someone right away, call the Veterans Crisis Line at 988. Then select 1.";

// line used by all PDFs and txt files to denote the file origin
export const reportGeneratedBy = `Report generated by My HealtheVet on VA.gov on ${formatDateLong(
  new Date(),
)}`;

export const edipiNotFound = `NOTES:
1) This report may not show your complete DoD Military Service Information.
   Data prior to establishment of DEERS and full service reporting (c. 1980) 
   may not appear.
2) It is normal for the begin/end dates in DoD records, adjusted by the
   Personnel Center after separation, to vary slightly from the DD-214.
3) No peacetime deployments will be displayed.  For Gulf War I, only one
   period will be displayed even if you deployed more than once.  No conflict
   prior to Gulf War I will be displayed.  Kosovo, Bosnia, and Southern Watch
   data is incomplete and may not display.
4) For Guard/Reserve, periods of active duty may not display.  No periods of
   Active duty service less than 30 days will display.
   
   ** No data was found. **`;

export const ALERT_TYPE_SEI_ERROR = 'self-entered download error';

// used to show failed call list (shows emergency contacts)
export const SEI_DOMAIN_DISPLAY_MAP = {
  activityJournal: 'Activity journal',
  allergies: 'Allergies',
  demographics: 'Demographics',
  emergencyContacts: 'Emergency contacts',
  familyHistory: 'Family health history',
  foodJournal: 'Food journal',
  providers: 'Healthcare providers',
  healthInsurance: 'Health insurance',
  testEntries: 'Lab and test results',
  medicalEvents: 'Medical events',
  medications: 'Medications and supplements',
  militaryHistory: 'Military health history',
  treatmentFacilities: 'Treatment facilities',
  vaccines: 'Vaccines',
  vitals: 'Vitals and readings',
};

// used to reference the sections of the SEI document
// (does not show emergency contacts because it is only a sub-section)
export const selfEnteredDocSections = {
  ACTIVITY_JOURNAL: 'activity journal',
  ALLERGIES: 'allergies',
  DEMOGRAPHICS: 'demographics',
  FAMILY_HISTORY: 'family health history',
  FOOD_JOURNAL: 'food journal',
  HEALTH_PROVIDERS: 'healthcare providers',
  HEALTH_INSURANCE: 'health insurance',
  TEST_ENTRIES: 'lab and test results',
  MEDICAL_EVENTS: 'medical events',
  MEDICATIONS: 'medications and supplements',
  MILITARY_HISTORY: 'military health history',
  TREATMENT_FACILITIES: 'treatment facilities',
  VACCINES: 'vaccines',
  VITALS: 'vitals and readings',
};

// All SEI domains in one place for easy iteration
export const SEI_DOMAINS = [
  'activityJournal',
  'allergies',
  'demographics',
  'emergencyContacts',
  'familyHistory',
  'foodJournal',
  'providers',
  'healthInsurance',
  'testEntries',
  'medicalEvents',
  'medications',
  'militaryHistory',
  'treatmentFacilities',
  'vaccines',
  'vitals',
];

export const UNKNOWN = 'Unknown';
export const NONE_ENTERED = 'None entered';

export const seiVitalTypes = {
  BLOOD_PRESSURE: 'bloodPressure',
  BLOOD_SUGAR: 'bloodSugar',
  BODY_TEMPERATURE: 'bodyTemperature',
  BODY_WEIGHT: 'bodyWeight',
  CHOLESTEROL: 'cholesterol',
  HEART_RATE: 'heartRate',
  INR: 'inr',
  PAIN: 'pain',
  PULSE_OXIMETRY: 'pulseOximetry',
};

// Allergy observed/reported types - used by Medical Records and Medications apps
export const allergyTypes = {
  OBSERVED:
    'Observed (you experienced this allergy or reaction while you were getting care at this VA location)',
  REPORTED:
    'Historical (you experienced this allergy or reaction in the past, before you started getting care at this VA location)',
};

// Emergency cutover lock tool keys — must match the values returned by vets-api
export const EMERGENCY_CUTOVER_LOCK_KEYS = Object.freeze({
  SM: 'sm',
  RX: 'rx',
  MR: 'mr',
  APPOINTMENTS: 'appointments',
});
